import { render } from "./Changelog.vue?vue&type=template&id=07d7e7f1&scoped=true"
import script from "./Changelog.vue?vue&type=script&lang=js"
export * from "./Changelog.vue?vue&type=script&lang=js"

import "./Changelog.vue?vue&type=style&index=0&id=07d7e7f1&scoped=true&lange=scss&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\40\\s\\PASVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d7e7f1"]])

export default __exports__